import { Controller } from "stimulus"

export default class extends Controller
  scrollTo: (event) ->
    target = event.currentTarget
    scrollTo = target.dataset.scrollTo

    if scrollTo
      $(scrollTo).smoothScroll(target.dataset.scrollPaddingTop or 21)
